import { EnrichedGroupNode } from './NodeEnricher/NodeEnricher';
import { TreeBrowserNode } from './TreeBrowser/types';

export const getDocumentHandlerId = (
  node: TreeBrowserNode<EnrichedGroupNode>,
) => {
  // a document can have multiple document handlers, just show the first one
  return node.enrichedFields?.documentHandlerId?.split(',')[0];
};

export const getResourceUrl = (
  node: TreeBrowserNode<EnrichedGroupNode>,
): string | null => {
  const documentHandlerId = getDocumentHandlerId(node);
  const { resourceType, resourceId } = node.attributes;

  switch (resourceType) {
    case 'document':
      return `/document/${documentHandlerId}`;
    case 'ticket':
      return `/workflow/tickets/${resourceId}`;
    default:
      return null;
  }
};
